<template>
    <div class="comparison-panel">
        <div class="compare-panel__back-drop"></div>
        <div class="comparison-panel__plans">
            <div class="comparison-panel__notification">
                {{app.notices.swipe}}
                <div class="icon-holder"><img src="/wp-content/themes/bdi-child/dist/img/icon_swipe-left.svg" alt=""></div>
            </div>
            <div class="comparison-panel__table">
                <table>
                    <tr>
                        <th scope="row" class="comparison-panel__table__heading">
                            <div>    
                                <a href="" @click.prevent="cancel"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 197.402 197.402"><path fill="#ffffff" d="M146.883 197.402L45.255 98.698 146.883 0l5.265 5.418-96.039 93.28 96.039 93.282z"/></svg></a>
                                <a href="" @click.prevent="cancel">{{app.labels.BACK_TO_PLANS}}</a>
                            </div>
                        </th>
                        <th scope="row" v-for="(plan, index) in plans" :key="'plan-' + index" :class="{'td--blue': index === 0, 'td--emerald': index === 1, 'td--tur': index === 2, 'td--green': index === 3}">
                            <div>
                                <a class="close" href="#" @click.prevent="removeColumn(index)"></a>
                                {{getPlan(plan).title}}
                            </div>
                        </th>
                    </tr>
                    <tr v-for="(field, index) in fieldsMeta" :key="'row-' + index">
                        <th class="comparison-panel__table__heading">{{field.label}}</th>
                        <template v-if="fieldsData">
                                <td v-for="(fieldData, fx) in fieldsData" :key="'field-' + fx">
                                    <template v-if="fieldData.details[field.name]">
                                        {{fieldData.details[field.name]}}
                                    </template>
                                    <template v-else>
                                        -
                                    </template>
                                </td>
                        </template>
                        <template v-if="!fieldsData.length && !index">
                            <td v-for="(plan, x) in plans" :key="'l-' + x" :rowspan="fieldsMeta.length" class="loading-cell"><spinner></spinner></td>
                        </template>
                    </tr>
                    <template v-if="fieldsData.length">
                        <tr>
                            <th></th>
                            <td v-for="(fieldData, idx) in fieldsData" :key="'apply-' + idx">
                                <a class="plan-cta" :href="fieldData.details.url">{{app.labels.APPLY}}</a>
                            </td>
                        </tr>
                    </template>
                </table>
            </div><!--/comparison-panel__table-->
        </div><!--/comparison-panel__plans-->
    </div><!--/comparison-panel-->
</template>

<script type="text/javascript">
import {mapActions, mapState} from 'vuex'
import Spinner from './Spinner'
import {request} from 'utility'

export default {
    data () {
        return {
            app: window.app,
            fieldsMeta: window.fieldsMeta,
            activePlans: window.activePlans,
            fieldsData: [],

        }
    },
    computed: {
        ...mapState([
            'plans',
            'loadingData'
        ])
    },
    components: {
        'spinner': Spinner
    },
    methods: {
        ...mapActions([
            'updateLoadingData',
            'updateComparing',
            'updateCompareMode',
            'updatePlans',
            'removePlan'
        ]),
        cancel () {
            this.updateComparing(false)
            this.updateCompareMode(false)
            this.updatePlans([])
            this.fieldsData = []
        },
        removeColumn(idx) {
            this.fieldsData.splice(idx, 1)
            this.removePlan(idx)

        },
        removeNullRows(data) {
            return this.fieldsMeta.filter(fieldMeta => {                
                for (let i = 0; i < data.length; i++) {
                    if (data[i].details[fieldMeta.name]) {
                        return true
                    }
                }

                return false
            })   
        },
        getPlan(id) {
            return this.activePlans.find(i => i.id === id)
        }
    },
    mounted() {
        let self = this
        request({
            url: window.settings.ajaxUrl,
            data: {
                action: 'plan_details',
                plans: this.plans
            }
        })

        .then (response => {
            self.fieldsMeta = this.removeNullRows(response.data.plans)
            self.fieldsData = response.data.plans
        })

        window.scrollTo(0, 0)
    }
}
</script>